import React from 'react';
import { Avatar, AvatarGroup, Box, Tooltip, Typography } from '@mui/material';
import { colorFor, initialsFor, MEMBER_ROLE_LABELS, sortMembers } from './memberRoles';

/**
 * The faces on a bet or a cycle, as a compact strip.
 *
 * Says "nobody on this yet" rather than rendering nothing, because an empty
 * space reads as "this component has not loaded" while a bet in flight with no
 * team is a real thing worth noticing.
 */
const MemberAvatars = ({
  members = [],
  max = 4,
  size = 26,
  emptyLabel = 'Nobody on this yet',
  showEmpty = true,
}) => {
  const sorted = sortMembers(members);

  if (!sorted.length) {
    if (!showEmpty) return null;
    return (
      <Typography variant="caption" color="text.secondary">
        {emptyLabel}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <AvatarGroup
        max={max}
        sx={{
          '& .MuiAvatar-root': {
            width: size,
            height: size,
            fontSize: size * 0.42,
            borderWidth: 1,
          },
        }}
      >
        {sorted.map(member => (
          <Tooltip
            key={member.userId}
            title={`${member.name || 'Unknown'}${member.role && member.role !== 'member' ? ` · ${MEMBER_ROLE_LABELS[member.role] || member.role}` : ''}`}
          >
            <Avatar alt={member.name || 'Unknown'} sx={{ bgcolor: colorFor(member.userId || member.name) }}>
              {initialsFor(member.name)}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default MemberAvatars;
